import React from "react";
import { observer, inject } from "mobx-react";
import { replaceStaticHost } from "Helpers/ImageManager";
import images from "Configs/images.config";
import WithSeoText from "Layouts/WithSeoText";
import BreadCrumbsContainer from "Containers/BreadCrumbsContainer";
import { PageTitleHeader, PageTitleWrapper } from "ComponentsUI/PageTitleBanner";

const HeaderWrapperContainer = (props) => {
	let {
		ApplicationModel: {
			windowSizeModel: { windowSizes },
			currentRegion,
			text,
		},
		seoData,
	} = props;

	const imagePageTitle =
		!!currentRegion && !!currentRegion.image_lg
			? {
					lg: replaceStaticHost(currentRegion.image_lg),
					md: replaceStaticHost(currentRegion.image_md),
					sm: replaceStaticHost(currentRegion.image_sm),
					xs: replaceStaticHost(currentRegion.image_xs),
				}
			: {
					lg: replaceStaticHost(images.heroBannerLg),
					md: replaceStaticHost(images.heroBannerMd),
					sm: replaceStaticHost(images.heroBannerSm),
					xs: replaceStaticHost(images.heroBannerXs),
				};

	const upper = <BreadCrumbsContainer white={!props.withoutBackground} />;
	const bottom = (
		<PageTitleHeader
			white={!props.withoutBackground}
			text={seoData?.h1}
			textAfter={seoData?.h1After}
		/>
	);
	let button = null;

	return (
		<>
			<PageTitleWrapper
				upper={!props.withoutUpper ? upper : null}
				bottom={bottom}
				background={!props.withoutBackground ? imagePageTitle : null}
				button={button}
				windowSizes={windowSizes}
				isAction={true}
			/>
			<WithSeoText seoData={seoData} text={text}>
				{props.children}
			</WithSeoText>
		</>
	);
};

export default inject("ApplicationModel")(observer(HeaderWrapperContainer));
